<ion-card class="app-background ion-padding">
  <ion-grid class="ion-no-padding">
    <ion-row>
      <ion-col size="12" class="ion-no-padding steps"> </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center ion-text-center ion-margin-top">
      <ion-col size="12" size-md="8" size-lg="6">
        <ion-label class="panel-header-text" color="dark">
          {{ 'register_step6Succeeded' | translate }}
        </ion-label>
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center ion-text-center">
      <ion-col size="11" size-md="10">
        <p class="ion-margin-top color-dark">
          {{ 'register_step6SucceededInfo' | translate }}
        </p>
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center ion-margin-top">
      <ion-col size="10" size-md="6" size-lg="4">
        <ion-button
          expand="block"
          color="primary"
          class="ion-margin-vertical"
          (click)="goToLogin()"
        >
          <small>{{ 'register_toLogin' | translate }}</small>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-card>
